import * as ActionTypes from "../constants/ActionTypes";

// **************************************************************************************************************
export const contentPopupReducer = (state = {popupVisible: false, popupData: {}}, action) => {

    switch (action.type) {

        case ActionTypes.POPUP_SHOW_OFFER_SHARING:
            return Object.assign({}, state, {popupVisible: true, popupData: {type: 'share'}})

        case ActionTypes.POPUP_SHOW_IFRAME:
            return Object.assign({}, state, {popupVisible: true, popupData: {type: 'iframe', src: action.src}})

        case ActionTypes.POPUP_CLOSE_ANY:
            return Object.assign({}, state, {popupVisible: false, popupData: {}})

        default:
            return state
    }

}



/** WEBPACK FOOTER **
 ** ./src/reducers/ContentPopup.js
 **/